import React from "react";
import PropTypes from "prop-types";
import { FEATURED_CITIES } from "config/featuredCitiesList";

import { Container, Section } from "components/core/Page";
import { Link } from "components/core/Link";
import { Image } from "@sparefoot/react-commons";
import { H3, Paragraph, ListItem } from "components/core/Typography";

import FeaturedCitiesSVG from "assets/images/featured-cities.svg";
import { connect } from 'react-redux';
import "./FeaturedCities.scss";

const ensureAbsoluteUrl = (url, baseUrl) => {
	if (!url || !baseUrl) return url;
	
	try {
		const parsedUrl = new URL(url);
		// Extract pathname and search parameters, combine with baseUrl
		return `${baseUrl}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
	} catch (error) {
		// If URL parsing fails, return original URL as fallback
		return url;
	}
};

const mapStateToProps = (state) => ({
	baseUrl: state.app?.baseUrl,
});

const FeaturedCities = ({ baseUrl }) => (
		<Section
			flush
			className="featured-cities"
		>
			<Container>
				<div className="into">
					<Image
						className="icon-image"
						lazy
						src={FeaturedCitiesSVG}
						alt="A large map pin with a star in front of buildings"
						width="120"
						height="120"
					/>
					<H3
						size="xxlarge"
						mediumSize="large"
					>
						Featured Cities
					</H3>
					<Paragraph>
						{" "}
						Find storage units in these popular locations:{" "}
					</Paragraph>
				</div>
				<div className="city-list">
					<ul className="list">
						{FEATURED_CITIES.map(({ text, url }) => (
							<ListItem
								className="list-item"
								color="blue"
								weight="semiBold"
								key={text}
								size="small"
							>
								<Link
									underline
									hover
									href={ensureAbsoluteUrl(url, baseUrl)}
								>
									{text}
								</Link>
							</ListItem>
						))}
					</ul>
				</div>
			</Container>
		</Section>
	);

FeaturedCities.propTypes = {
	baseUrl: PropTypes.string
};

// Export unwrapped component for testing
export { FeaturedCities, ensureAbsoluteUrl};

export default connect(mapStateToProps)(FeaturedCities);
